// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3Zt4Q","left":"StickyBox_left__1ugHa","right":"StickyBox_right__23wT5"};